import useWindowSize from "../../hooks/useWindowSize";

export const Loader = ({path = '..'}) => {
    return(
        <div className="c-loading">
            <img src={`${path}/images/loading-3s.gif`} alt="Loading" />
        </div>
    )
}

export const LoadingContent = () => {
    return(
        <div className="c-loadingContent">
            <img src="../images/loading-3s.gif" alt="Loading" />
        </div>
    )
}

export const CommingSoon = () => {
    const size = useWindowSize();
    return(
        <div className="c-commingSoon">
            {size.width >= 1024 ? <img src="../images/comingSoon-pc.gif" alt="Comming Soon" /> : <img src="../images/comingSoon-tablet.gif" alt="Comming Soon" />}
        </div>
    )
}